import { useMemo } from 'react';
import { dimensionsCategory } from '@utils/dimension/dimensionCategories';
import { CURRENT_PRODUCT_MODE } from '@utils/constants';

function useDimensionsCategories({
  allDimensions,
  selectedDimensionsList,
  excludeCategories = [] as string[],
  excludeDimensions = [] as string[],
  hiddenEmptyCategory = false,
}) {
  const dimensionsCategories = useMemo(() => {
    const categoryMap = {};
    const currentDimensionCategory = dimensionsCategory[CURRENT_PRODUCT_MODE];
    Object.keys(currentDimensionCategory).forEach((category) => (categoryMap[category] = []));

    allDimensions.forEach(
      ({
        category,
        groupBy,
        name,
        isDeployed = true,
        isPredefined = true,
        isHighCardinality = false,
      }) => {
        if (category && !excludeDimensions.includes(groupBy)) {
          const checked = selectedDimensionsList.includes(groupBy);

          categoryMap[category]?.push({
            key: groupBy,
            name: name,
            checked,
            isDeployed,
            isPredefined,
            isHighCardinality,
          });
        }
      },
    );

    // exclude ad category when FF is false
    excludeCategories.forEach((category) => {
      delete categoryMap[category];
    });

    for (const category of Object.keys(categoryMap)) {
      categoryMap[category].sort((a, b) => a.name.localeCompare(b.name));
      /** [remove category that not have dimensions](https://conviva.atlassian.net/browse/HP-8426) */
      if (categoryMap[category].length === 0) {
        delete categoryMap[category];
      }
    }

    if (hiddenEmptyCategory) {
      Object.keys(categoryMap).map((it) => {
        if (!categoryMap[it] || !categoryMap[it].length) {
          delete categoryMap[it];
        }
      });
    }

    return categoryMap;
  }, [
    allDimensions,
    selectedDimensionsList,
    excludeCategories,
    excludeDimensions,
    hiddenEmptyCategory,
  ]);

  return dimensionsCategories;
}

export default useDimensionsCategories;
